import React from "react";

import { useSectionList } from "src/modules/ltx/dashboard";
import { useHeaderValues } from "src/modules/ltx/header";
import { Report as BareReport } from "src/modules/shared/dashboard";

export const Report: React.FunctionComponent = () => {
	const header = useHeaderValues();
	const sections = useSectionList();
	return <BareReport header={header} sections={sections} />;
};
